module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-cafe-1.11c84f7b.jpg";